import { create } from 'zustand'
import { Button } from './button'
import { Dialog } from './dialog'

interface ConfirmOptions {
  title: string
  description?: string
  confirmLabel?: string
  cancelLabel?: string
  variant?: 'primary' | 'danger'
}

interface ConfirmState {
  open: boolean
  options: ConfirmOptions | null
  resolve: ((value: boolean) => void) | null
  show: (opts: ConfirmOptions) => Promise<boolean>
  close: (result: boolean) => void
}

const useConfirmStore = create<ConfirmState>((set, get) => ({
  open: false,
  options: null,
  resolve: null,
  show: (opts) => {
    return new Promise<boolean>((resolve) => {
      set({ open: true, options: opts, resolve })
    })
  },
  close: (result) => {
    const { resolve } = get()
    resolve?.(result)
    set({ open: false, options: null, resolve: null })
  },
}))

export function confirm(opts: ConfirmOptions): Promise<boolean> {
  return useConfirmStore.getState().show(opts)
}

export function ConfirmDialogHost() {
  const { open, options, close } = useConfirmStore()
  if (!options) return null

  return (
    <Dialog
      open={open}
      onClose={() => close(false)}
      title={options.title}
      description={options.description}
      footer={
        <>
          <Button variant="ghost" onClick={() => close(false)} type="button">
            {options.cancelLabel ?? 'Abbrechen'}
          </Button>
          <Button
            variant={options.variant === 'danger' ? 'danger' : 'primary'}
            onClick={() => close(true)}
            type="button"
          >
            {options.confirmLabel ?? 'Bestätigen'}
          </Button>
        </>
      }
    >
      <div className="pb-4" />
    </Dialog>
  )
}
